const ACTIVE_CANONICAL = "ACTIVE";
const INACTIVE_CANONICAL = "INACTIVE";

const ACTIVE_STATES = new Set(["ACTIVO", "ACTIVE", "ACTIU"]);
const INACTIVE_STATES = new Set(["BAJA", "INACTIVE", "INACTIVO", "INACTIU"]);

export const normalizeBinaryState = (state?: string | null, deletedAt?: unknown): string => {
    if (state) {
        const normalized = state.trim().toUpperCase();
        if (INACTIVE_STATES.has(normalized)) {
            return INACTIVE_CANONICAL;
        }

        if (ACTIVE_STATES.has(normalized)) {
            return ACTIVE_CANONICAL;
        }
    }

    return deletedAt ? INACTIVE_CANONICAL : ACTIVE_CANONICAL;
};

export const isInactiveState = (state?: string | null, deletedAt?: unknown): boolean => normalizeBinaryState(state, deletedAt) === INACTIVE_CANONICAL;
export const isActiveState = (state?: string | null, deletedAt?: unknown): boolean => normalizeBinaryState(state, deletedAt) === ACTIVE_CANONICAL;
